import { TableFilterModel } from "models/TableFilterModel";
import { BaseService } from "./base.service";
import {
	IOrganizationEvaluationNumber,
	IOrganizationPriceEvaluationSettingSummaryGridDetail,
	IOrganizationPriceEvaluationSettingDetail,
} from "models/OrganizationEvaluationSettingModel";

class OrganizationEvaluationSettingServiceInternal extends BaseService {
	getAllNumberList = async (): Promise<IOrganizationEvaluationNumber[]> =>
		this.callApi<IOrganizationEvaluationNumber[]>(
			`OrganizationPriceEvaluationSetting/GetAllNumberList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	getOrganizationEvaluationSettingGridList = async (
		model: TableFilterModel
	): Promise<IOrganizationPriceEvaluationSettingSummaryGridDetail[]> =>
		this.callApi<IOrganizationPriceEvaluationSettingSummaryGridDetail[]>(
			`OrganizationPriceEvaluationSetting/GetAll`,
			"POST",
			undefined,
			model
		);

	getOrganizationEvaluationSettingDetailById = async (
		organizationPriceEvaluationSettingId: number
	): Promise<IOrganizationPriceEvaluationSettingDetail> =>
		this.callApi<IOrganizationPriceEvaluationSettingDetail>(
			`OrganizationPriceEvaluationSetting/GetById/${organizationPriceEvaluationSettingId}`,
			"GET",
			undefined
		);

	saveUpdate = async (
		model: IOrganizationPriceEvaluationSettingDetail
	): Promise<number> => {
		return this.callApi<number>(
			`OrganizationPriceEvaluationSetting/SaveUpdate`,
			"POST",
			undefined,
			model
		);
	};

	getActivePriceEvaluationId = async (
		bidId: number
	): Promise<number | null> => {
		return this.callApi<number | null>(
			`OrganizationPriceEvaluationSetting/GetActivePriceEvaluationMethodId/${bidId}`,
			"GET",
			undefined,
			undefined
		);
	};

	deletePriceAndBeeSetting = async (
		organizationPriceEvaluationSettingId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`OrganizationPriceEvaluationSetting/Delete/${organizationPriceEvaluationSettingId}`,
			"DELETE"
		);

	updateStatus = async (
		organizationPriceEvaluationSettingId: number,
		statusId: number,
		isForceActive: boolean
	): Promise<number> => {
		return this.callApi<number>(
			`OrganizationPriceEvaluationSetting/UpdateStatus/${organizationPriceEvaluationSettingId}/${statusId}/${isForceActive}`,
			"POST",
			undefined,
			undefined
		);
	};
}

export const OrganizationEvaluationSettingService =
	new OrganizationEvaluationSettingServiceInternal();
